import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Form, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { GestionContextService } from "../../context/getion-context.service";
import { GestionService } from "../../services/gestion.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-mantenimiento-campanyas',
    templateUrl: './mantenimiento-campanyas.component.html'
})
export class MantenimientoCampanyasComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;
    public dropdownInfo: number;

    public campanyas;
    //public denominaciones;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showErrorWarning: boolean;

    public disabledDenominaciones: Subject<boolean> = new Subject();

    public deleteModal = false;
    public newEditModal = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public toEditId;
    public toDeleteId;

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _gestionContext: GestionContextService,
        private readonly _gestionService: GestionService,
        private readonly _dataProvider: DataProvider,
        private readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ){}

    ngOnInit() {
        this.filtersForm = this._fb.group({
            pais: [''],
            inicioCampanya: [''],
            finCampanya: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false'],
            denominacion: [''],
            campanya: ['']
        });

        this._gestionContext.mantenimientoCampanyasFilters = null;

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('inicioCampanya').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('finCampanya').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.getCampanyas();

        // this.filtersForm.get('pais').valueChanges.subscribe((pais) => {
        //     if (pais) {
        //         const filters = {
        //             paisId: pais.id
        //         };
        //         this.filtersForm.get('denominacion').enable({ emitEvent: false });
        //         this.filtersForm.get('denominacion').patchValue('');
        //         this._spinnerService.showSpinner();
        //         this._gestionService.getDenominaciones(filters).toPromise().finally(() => {
        //             this._spinnerService.hideSpinner();
        //         }).then((resp) => {
        //             this.denominaciones = resp.lista;
        //         });
        //         this.disabledDenominaciones.next(false);
        //     } else {
        //         this.filtersForm.get('denominacion').disable({ emitEvent: false });
        //         this.filtersForm.get('denominacion').patchValue('');
        //         this.disabledDenominaciones.next(true);
        //         this.denominaciones = null;
        //     }
        //   });

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get campaigns() {
        return this._dataProvider.campaigns;
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public validDates() {
        this.checkDatePair('fechaInicio', 'fechaFin');
        this.checkDatePair('inicioCampanya', 'finCampanya');

        if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid ||
            this.filtersForm.get('inicioCampanya').invalid || this.filtersForm.get('finCampanya').invalid) {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
        } else {
          this.showError = false;
          this.mensajes = [];
        }
    }

    private checkDatePair(fecha1, fecha2) {
        if (this.filtersForm.get(fecha1).value && this.filtersForm.get(fecha2).value) {
          if (this.checkDates(this.filtersForm.get(fecha1).value, this.filtersForm.get(fecha2).value)) {
            this.clearDatesValidators(fecha1, fecha2);
          } else {
            this.filtersForm.get(fecha1).setErrors(['Invalid date']);
            this.filtersForm.get(fecha2).setErrors(['Invalid date']);
          }
        } else {
          this.clearDatesValidators(fecha1, fecha2);
        }
    }

    private clearDatesValidators(fecha1, fecha2) {
        if (this.filtersForm.get(fecha2).errors && this.filtersForm.get(fecha2).errors.includes('Invalid date')) {
          this.filtersForm.get(fecha2).clearValidators();
          this.filtersForm.get(fecha2).updateValueAndValidity();
        }
        if (this.filtersForm.get(fecha1).errors && this.filtersForm.get(fecha1).errors.includes('Invalid date')) {
          this.filtersForm.get(fecha1).clearValidators();
          this.filtersForm.get(fecha1).updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public get denominaciones() {
        return this._dataProvider.denominaciones;
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this._gestionContext.mantenimientoCampanyasFilters.numPagina = this.currentPage = page -1;
        this.getCampanyas();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this._gestionContext.mantenimientoCampanyasFilters.numPagina = this.currentPage = 0;
        this._gestionContext.mantenimientoCampanyasFilters.tamPagina = this.itemsPerPage = items;
        this.getCampanyas();
    }

    public checkValuesForm(): boolean {
        return ((this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
                this.filtersForm.get('denominacion').value ||
                this.filtersForm.get('campanya').value ||
                this.filtersForm.get('inicioCampanya').value ||
                this.filtersForm.get('finCampanya').value ||
                this.filtersForm.get('fechaInicio').value ||
                this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            dateType: 'false'
        });
        //this.filtersForm.get('dateType').patchValue('false');
    }

    public applyFilters() {
        this.currentPage = 0;
        this._gestionContext.mantenimientoCampanyasFilters = {
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '' ,
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : '' ,
            des: this.filtersForm.get('campanya').value ? this.filtersForm.get('campanya').value : '' ,
            cargaRegistroEnUso: true,
            fechaInicioCampanya: this.filtersForm.get('inicioCampanya').value ?
            this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('inicioCampanya').value) : '',
            fechaFinCampanya: this.filtersForm.get('finCampanya').value ?
            this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('finCampanya').value) : '',
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        }
        this.getCampanyas();
    }

    public getCampanyas() {
        if (this._gestionContext.mantenimientoCampanyasFilters) {
            this._filters = this._gestionContext.mantenimientoCampanyasFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._gestionService.getCampanyas(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.campanyas = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public create() {
        this.toEditId = null;
        this.newEditModal = true;
    }

    public update(campanya) {
        this.toEditId = campanya.id;
        this.newEditModal = true;
    }

    public askDelete(campanya) {
        this.toDeleteId = campanya.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._gestionService.deleteCampanya(this.toDeleteId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getCampanyas();
        });
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
          this.getCampanyas();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        this.mensajes.push({ class: 'success', message: mensaje });
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
        // Desplazamiento al principio del panel "Más información" para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
          // Retardo: en caso de que haya otro panel abierto
          setTimeout(() => {
            document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
          }, 50);
        }
    }

    public getIcon(prop: string, idColumn: number) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 && this.columnId === idColumn) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
      this.columnId = idColumn;
      if (this.campanyas && this.campanyas.length > 0) {
        if (this._gestionContext.mantenimientoCampanyasFilters) {
          this._filters = this._gestionContext.mantenimientoCampanyasFilters;
          if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: false
              }
            ];
          } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: true
              }
            ];
          }
          this.getCampanyas();
        }
      }
    }

    public createFincaPruebas(campanya) {
      if (campanya.habilitada) {
        this._spinnerService.showSpinner();
        const desFincaPruebas = {
          campanyaId: campanya.id
        }
        this._gestionService.createDesignacionesFincaPruebas(desFincaPruebas).toPromise().finally(() => {
          this._spinnerService.hideSpinner();
        }).then((resp) => {
          this.showError = true;
          this.mensajes.push({ class: 'success', message: 'global.success.itemCreated'});
        }), (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.noResponse'});
        }
      }
    }

    public trackByCampanyaId(index: number, campanya: { id: number }): number {
      return campanya.id;
    }
}
